import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { CostCenterOption } from './cost-center-options.model';
import {
  getCostCenterOptionsStore,
  CostCenterOptionsStore,
  CostCenterOptionsUiState,
} from './cost-center-options.store';
import { CostCenterOptionsForm } from './cost-center-options.forms';
import { dispatchForm } from '../forms';
import { CorporateAccountApi } from '../api/generated/reservations';

export class CostCenterOptionsService {
  constructor(
    private readonly store: CostCenterOptionsStore,
    private readonly corporateAccountApi: CorporateAccountApi
  ) {}

  updateCostCenterOptions(corporateAccountId: string, options: CostCenterOption[]) {
    from(
      this.corporateAccountApi.corporateaccountIdOptionsPost(corporateAccountId, {
        options,
      })
    )
      .pipe(
        map(response => response.data.data),
        dispatchForm(CostCenterOptionsForm.Edit)
      )
      .subscribe(results => {
        this.store.set(results);
        this.updateUI({
          corporateAccountId,
        });
      });
  }

  getCostCenterOptions(corporateAccountId: string) {
    from(this.corporateAccountApi.corporateaccountIdOptionsGet(corporateAccountId))
      .pipe(map(response => response.data.data))
      .subscribe(options => {
        this.store.upsertMany(options);
        this.updateUI({
          corporateAccountId,
        });
      });
  }

  public reset() {
    this.store.reset();
  }

  private updateUI(values: Partial<CostCenterOptionsUiState>) {
    this.store.update(({ ui }) => ({
      ui: {
        ...ui,
        ...values,
      },
    }));
  }
}

// REPLACE with a lazy getter function:
let _service: CostCenterOptionsService | undefined;
export function getCostCenterOptionsService(): CostCenterOptionsService {
  if (!_service) {
    _service = new CostCenterOptionsService(getCostCenterOptionsStore(), new CorporateAccountApi());
  }
  return _service;
}
